/** React Imports */
import React, { Component } from "react";
import {
  Create,
  SimpleForm,
  FileInput,
  FileField,
  Toolbar,
  CREATE,
  GET_LIST,
  required
} from "react-admin";
/** Middleware Imports */
import { restClient } from "ra-data-feathers";
import feathersClient from "../feathersClient";
/** Material UI Imports */
import Badge from "@material-ui/core/Badge";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CloudUpload from "@material-ui/icons/CloudUpload";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import SaveButton from "ra-ui-materialui/lib/button/SaveButton";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";

const dataProvider = restClient(feathersClient, { id: "_id", usePatch: true });

export class OperacionCreate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentFile: null,
      result: null,
      isSaving: false,
      operationsSinceToday: 0
    };
    this.clickHandler = this.handleClick.bind(this);
    this.fileHandler = this.onFileChange.bind(this);
  }

  componentDidMount() {
    dataProvider(GET_LIST, "operaciones", {}).then(response => {
      this.setState({
        operationsSinceToday: response.data.length
      });
    });
  }

  onFileChange(file) {
    this.setState({ currentFile: file });
  }

  handleClick() {
    if (!this.state.isSaving && this.state.currentFile) {
      this.setState({ isSaving: true });
      convertFileToBase64(this.state.currentFile).then(convertedFile => {
        dataProvider(CREATE, "operaciones", { data: { uri: convertedFile } })
          .then(resp => {
            this.setState({
              result: resp.data.data,
              operationsSinceToday: resp.data.data.cantidadDeOperaciones
            });
          })
          .finally(() => {
            this.setState({ isSaving: false });
          });
      });
    }
  }

  render() {
    return (
      <Grid container>
        <Grid item xs={12}>
          <Create
            {...this.props}
            title="Importar Operaciones"
            actions={
              <CustomFabIcon
                operationsSinceToday={this.state.operationsSinceToday}
              />
            }
          >
            <SimpleForm
              toolbar={
                <OperacionToolbar
                  isSaving={this.state.isSaving}
                  handleClick={this.clickHandler}
                />
              }
              redirect={false}
            >
              <FileInput
                onChange={this.fileHandler}
                source="uri"
                label="Planilla de Operacion"
                accept="application/vnd.ms-excel"
                validate={[required()]}
              >
                <FileField source="src" title="title" />
              </FileInput>
              {this.state.result ? (
                <ResultadoDeCarga result={this.state.result} />
              ) : null}
            </SimpleForm>
          </Create>
        </Grid>
      </Grid>
    );
  }
}

class CustomFabIcon extends Component {
  render() {
    const { operationsSinceToday } = this.props;
    if (operationsSinceToday !== null) {
      return (
        <Tooltip
          title="Operaciones Cargadas en el día de hoy"
          enterDelay={500}
          leaveDelay={200}
          disableFocusListener
          disableTouchListener
        >
          <Badge
            style={{ margin: "15px" }}
            badgeContent={operationsSinceToday}
            color="error"
          >
            <Button mini={true} variant="fab" color="primary">
              <CloudUpload />
            </Button>
          </Badge>
        </Tooltip>
      );
    }
    return null;
  }
}

class OperacionToolbar extends Component {
  render() {
    return (
      <Toolbar saving={this.props.isSaving}>
        <SaveButton label="Subir" onClick={this.props.handleClick} />
      </Toolbar>
    );
  }
}

class ResultadoDeCarga extends Component {
  render() {
    return (
      <Card>
        <CardContent>
          <Typography variant="headline" component="h2">
            {" "}
            Pesajes importados correctamente:{" "}
            {this.props.result.pesajesImportados}{" "}
          </Typography>
          <CartonerosList
            title="Cartoneros sin ID"
            result={this.props.result.errors.cartonerosSinID}
          />
          <CartonerosList
            title="Cartoneros no Encontrados"
            result={this.props.result.errors.cartonerosNoEncontrados}
          />
        </CardContent>
      </Card>
    );
  }
}

class CartonerosList extends Component {
  render() {
    return (
      <ExpansionPanel>
        <ExpansionPanelSummary>
          <Typography> {this.props.title} </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <List className="root">
            {this.props.result.map(cartonero => {
              return (
                <ListItem key={cartonero}>
                  <ListItemText primary={cartonero} />
                </ListItem>
              );
            })}
          </List>
        </ExpansionPanelDetails>
      </ExpansionPanel>
    );
  }
}

const convertFileToBase64 = file =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file.rawFile);
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
  });



// WEBPACK FOOTER //
// ./src/services/operaciones.js